// components/FAIcon.tsx
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, BoxProps } from '@mantine/core';
import { library } from '@fortawesome/fontawesome-svg-core';
import { IconName, IconPrefix, IconLookup, findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faStar,
  faHome,
  faUser,
  faArrowRightLong,
  faArrowLeftLong,
  faChevronLeft,
  faTrashCan,
  faXmark,
  faFont,
  faImage,
  faTable,
  faArrowUp,
  faArrowDown,
  faClone,
  faBan,
  faEllipsisVertical,
  faTrash,
  faLocationDot,
  faAt,
  faUpload,
  faPhone,
  faPlus,
  faMinus,
  faEdit,
  faEye,
  faClock,
  faExclamationCircle,
  faExclamationTriangle,
  faCloudUpload,
  faFile,
  faCreditCard,
  faCalendar,
  faGlobe,
  faSpinner,
  faLink,
  faVideo,
  faCopy,
  faEllipsis,
  faCalendarPlus,
  faCalendarCheck,
  faGripHorizontal,
  faFilePdf,
  faLock,
  faChevronRight,
  faSun,
  faCloudSun,
  faMoon,
  faExternalLink,
  faInfoCircle,
  faChevronUp,
  faChevronDown,
  faEnvelope,
  faMailBulk,
  faRotate,
  faQuoteRight,
  faSearch,
  faSearchMinus,
  faTag,
  faFlag,
  faMapMarker,
  faBriefcase,
  faSave,
  faBuilding,
  faRoad,
  faPhotoFilm,
  faIdCard,
  faCheckCircle,
  faUserPlus,
  faUserGear,
  faDollar,
  faBell,
  faUserCheck,
  faUserTimes,
  faUserLock,
  faSort,
  faSync,
  faPause,
  faPlay,
  faStop,
  faCheckSquare,
  faChartLine,
  faPenToSquare,
  faDownload,
  faSignInAlt,
  faCloudArrowUp,
  faCloudArrowDown,
  faFileExcel,
  faAlignCenter,
  faAlignJustify,
  faAlignRight,
  faAlignLeft,
  faHeading,
  faBold,
  faSuperscript,
  faSubscript,
  faCode,
  faStrikethrough,
  faUnderline,
  faItalic,
  faListUl,
  faListOl,
  faBolt,
  faShield,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

import {
  faTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
  faLinkedinIn,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';

// Create an object with all icons for type safety
const iconSet = {
  check: faCheck,
  star: faStar,
  home: faHome,
  user: faUser,
  'arrow-right-long': faArrowRightLong,
  'arrow-left-long': faArrowLeftLong,
  'chevron-left': faChevronLeft,
  'trash-can': faTrashCan,
  xmark: faXmark,
  font: faFont,
  image: faImage,
  table: faTable,
  'arrow-up': faArrowUp,
  'arrow-down': faArrowDown,
  clone: faClone,
  ban: faBan,
  'ellipsis-vertical': faEllipsisVertical,
  ellipsis: faEllipsis,
  trash: faTrash,
  'location-dot': faLocationDot,
  at: faAt,
  upload: faUpload,
  phone: faPhone,
  plus: faPlus,
  minus: faMinus,
  edit: faEdit,
  eye: faEye,
  clock: faClock,
  'exclamation-circle': faExclamationCircle,
  'exclamation-triangle': faExclamationTriangle,
  'cloud-upload': faCloudUpload,
  file: faFile,
  'credit-card': faCreditCard,
  calendar: faCalendar,
  'calendar-plus': faCalendarPlus,
  'calendar-check': faCalendarCheck,
  globe: faGlobe,
  spinner: faSpinner,
  link: faLink,
  video: faVideo,
  copy: faCopy,
  // Brand icons
  twitter: faTwitter,
  facebook: faFacebook,
  instagram: faInstagram,
  linkedin: faLinkedin,
  'linkedin-in': faLinkedinIn,
  'grip-horizontal': faGripHorizontal,
  'file-pdf': faFilePdf,
  'chevron-right':faChevronRight,
  'cloud-sun':faCloudSun,
  'sun':faSun,
  'moon':faMoon,
  'external-link':faExternalLink,
  'info-circle':faInfoCircle,
  'x-twitter':faTwitter,
  lock:faLock,
  'chevron-up': faChevronUp,
  'chevron-down': faChevronDown,
  envelope: faEnvelope,
  mail: faEnvelope,
  rotate:faRotate,
  google: faGoogle,
  'quote-right': faQuoteRight,
  search:faSearch,
  'search-minus':faSearchMinus,
  'tag':faTag,
  'flag':faFlag,
  'map-marker':faMapMarker,
  'building':faBuilding,
  'check-circle':faCheckCircle,
  'shield':faBan,
  'briefcase':faBriefcase,
  'save':faSave,
  'city':faBuilding,
  'road':faRoad,
  'info':faInfoCircle,
  'photo':faPhotoFilm,
  'id-card':faIdCard,
  'default':faFilePdf,
  "user-plus":faUserPlus,
  'user-gear':faUserGear,
  'money-bill':faDollar,
  'bell':faBell,
  'user-check':faUserCheck,
  'user-times':faUserTimes,
  'user-lock':faUserLock,
  'registration':faUserPlus,
  'document':faFile,
  'payment':faDollar,
  'role_change':faUserGear,
  'dollar':faDollar,
  'sort' : faSort,
  'sync':faSync,
  'pause':faPause,
  'play':faPlay,
  'stop':faStop,
  'check-square':faCheckSquare,
  'chart-line':faChartLine,
  'pen-to-square':faPenToSquare,
  'download':faDownload,
  'sign-in-alt':faSignInAlt,
  'cloud-arrow-up':faCloudArrowUp,
  'cloud-arrow-down':faCloudArrowDown,
  'file-excel':faFileExcel,
  'align-center':faAlignCenter,
  'align-right':faAlignRight,
  'align-justify':faAlignJustify,
  'align-left':faAlignLeft,
  'heading':faHeading,
  'bold':faBold,
  'italic':faItalic,
  'underline':faUnderline,
  'strikethrough':faStrikethrough,
  'code':faCode,
  'superscript':faSuperscript,
  'subscript':faSubscript,
  'heading-1':faHeading,
  'heading-2':faHeading,
  'heading-3':faHeading,
  'heading-4':faHeading,
  'heading-5':faHeading,
  'heading-6':faHeading,
  'list-ul':faListUl,
  'list-ol':faListOl,
  'list-dl':faListOl,
  'bolt':faBolt,
  'shield-check':faShield,
  'users':faUsers,
} as const;

// Add all icons to the library
library.add(...Object.values(iconSet));

// Create a type for valid icon names
export type ValidIconName = keyof typeof iconSet;

const Root = styled(Box, {
  shouldForwardProp: (prop: PropertyKey) => !['size'].includes(prop.toString()),
})<Partial<FAIconCombinedProps>>(
  ({ size = 12 }) => css`
    position: relative;
    z-index: 1;
    display: inline-block;
    vertical-align: middle;
    font-size: ${size}px;
    line-height: 1;

    > svg {
      display: block;
      width: 1em;
      height: 1em;
    }
  `
);

export interface FAIconProps {
  name?: ValidIconName;
  size?: number;
  prefix?: IconPrefix;
  svg?: React.ReactNode;
}

export type FAIconCombinedProps = FAIconProps & BoxProps & JSX.IntrinsicElements['div'];

const FAIcon: React.FC<FAIconCombinedProps> = ({ name, prefix = 'fas', svg, ...props }) => {
  if (svg) {
    return <Root {...props}>{svg}</Root>;
  }

  if (!name) return null;

  // Get the icon definition
  const iconLookup: IconLookup = {
    prefix: prefix as IconPrefix,
    iconName: name as IconName,
  };

  const iconDefinition = findIconDefinition(iconLookup);

  if (!iconDefinition) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <Root {...props}>
      <FontAwesomeIcon icon={iconDefinition} />
    </Root>
  );
};

export default FAIcon;